import PrivateGalleryPage from "./PrivateGalleryPage";

export default PrivateGalleryPage;
